module.exports = __webpack_public_path__ + "img/y_2021_1.c3b862f5.png";